import mixpanel from "mixpanel-browser/dist/mixpanel-with-async-recorder.cjs";
import { MIXPANEL_TOKEN } from "../config";

/**
 * product funnels and flows
 * - one project per environment, picked by the token (staging / prod)
 * - only catalogue events reach Mixpanel
 */
const mixpanelDestination = {
  name: "mixpanel",
  preference: "analytics",
  enabled: () => Boolean(MIXPANEL_TOKEN),
  init: () =>
    mixpanel.init(MIXPANEL_TOKEN, {
      // already the SDK defaults, pinned so an upgrade can't turn them on;
      // page views arrive as page_viewed and replay starts per funnel instead
      track_pageview: false,
      autocapture: false,
      record_sessions_percent: 0,
      property_blacklist: ["$current_url", "$referrer", "$initial_referrer"]
    }),
  track: (name, props, event, options) =>
    mixpanel.track(
      name,
      props,
      options?.beacon
        ? { transport: "sendBeacon", send_immediately: true }
        : undefined
    ),
  identify: (userId, traits) => {
    mixpanel.identify(userId);
    mixpanel.people.set(traits);
  },
  reset: () => mixpanel.reset(),
  page: () => {}
};

export default mixpanelDestination;
